/** Non-hook PostHog flag read for utilities and event handlers (the hook is useFeatureFlag). */

import { posthog } from "@/config/posthog.config";

/**
 * Synchronous flag check, same semantics as `useFeatureFlag`: enabled in DEV builds (PostHog
 * isn't initialized on localhost), otherwise true only once PostHog has loaded the flag as on.
 *
 * @param flagKey - PostHog flag key.
 */
export function isFeatureFlagEnabled(flagKey: string): boolean {
  if (import.meta.env.DEV) return true;
  return posthog.isFeatureEnabled(flagKey) === true;
}
